// extracted by mini-css-extract-plugin
export default {"image":"image_ZRJ9A"};